(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    constructor() {
      super();
      this._handleOutsideClick = this._handleOutsideClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[id^="EmailSignup-"]');
      this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
      this.submitButton = this.form?.querySelector("button[id^='EmailSignup-submit-']");
      this.subscriptionForm = this.querySelector('.subscription-form');
      this.emailForm = this.querySelector('.email-signup__form');
      this.promoBtn = this.querySelector('.promo-btn');
      this.openNewsletterPopupButton = this.querySelector('.open-newsletter-popup-button');
      // this.backBtn = this.emailForm.querySelector('.back-btn');

      this.initAgreeCondition();
      this.initPromoToggle();
      this.openNewsletterPopup();

      if (window.location.search.includes('contact_posted=true')) {
        this.showEmailForm(true);
      }
    }

    initAgreeCondition() {
      if (!this.checkbox || !this.submitButton) return;

      this.submitButton.disabled = true;

      this.checkbox.addEventListener('change', () => {
        this.submitButton.disabled = !this.checkbox.checked;
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          alert('Please agree to the terms and conditions before submitting.');
        }
      });
    }

    initPromoToggle() {
      if (!this.subscriptionForm || !this.emailForm || !this.promoBtn) return;

      this.emailForm.style.display = 'none';

      this.promoBtn.addEventListener('click', () => this.showEmailForm());
      // this.backBtn?.addEventListener('click', () => this.showSubscriptionForm());
    }

    openNewsletterPopup() {
      if (!this.openNewsletterPopupButton) return;
      this.openNewsletterPopupButton.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = document.querySelector('.promotionPopup');
        if (popup) popup.setAttribute('open', '');
        const content = document.querySelector('.promotionPopup .popup__inner');
        Motion.timeline([
          [content, { opacity: [0, 1], transform: ['translate(-50%, -40%)', 'translate(-50%, -50%)'] }, { duration: 0.3, at: '-0.15' }]
        ]).finished;
      });
    }

    async showEmailForm(skipHideAnim = false) {
      if (!skipHideAnim) await this._animateHide(this.subscriptionForm);
      this.subscriptionForm.style.display = 'none';
      this.emailForm.style.display = '';
      await this._animateShow(this.emailForm);

      document.addEventListener('click', this._handleOutsideClick);
    }

    async showSubscriptionForm() {
      await this._animateHide(this.emailForm);
      this.emailForm.style.display = 'none';
      this.subscriptionForm.style.display = '';
      await this._animateShow(this.subscriptionForm);

      document.removeEventListener('click', this._handleOutsideClick);
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this.showSubscriptionForm();
      }
    }

    async _animateShow(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [
          element,
          { height: ['0px', `${element.scrollHeight}px`] },
          { duration: 0.15, easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
        [
          element,
          { opacity: [0, 1], transform: ['translateX(-1rem)', 'translateX(0)'] },
          { duration: 0.15, at: '-0.1' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }

    async _animateHide(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [element, { opacity: 0, transform: ['translateX(0)', 'translateX(1rem)'] }, { duration: 0.15 }],
        [
          element,
          { height: [`${element.clientHeight}px`, '0px'] },
          { duration: 0.15, at: '<', easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }
  }
  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ukh-fbt-inline"] && !Shopify.designMode) return;
  try {
    (() => {
  const fmt = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'PKR',
        currencyDisplay: 'code',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return 'PKR ' + Math.round(cents / 100).toLocaleString();
    }
  };

  const selectedCity = () => {
    try {
      const stored = localStorage.getItem('selected_city');
      if (stored) return stored;
    } catch (e) {}
    const match = document.cookie.match(/(?:^|;\s*)selected_city=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const init = (root) => {
    if (!root || root.dataset.fbtReady === 'true') return;
    root.dataset.fbtReady = 'true';

    const currency = root.dataset.currency || 'PKR';
    const button = root.querySelector('[data-fbt-add]');
    const total = root.querySelector('[data-fbt-total]');
    const itemsWrap = root.querySelector('[data-fbt-items]');
    const prev = root.querySelector('[data-fbt-prev]');
    const next = root.querySelector('[data-fbt-next]');
    const page = root.closest('.main-product-redesign');
    const defaultLabel = button?.dataset.fbtDefaultLabel || button?.textContent?.trim() || 'Add All to Cart';

    let cartVariantIds = new Set();
    let cartStateLoaded = false;
    let cartSyncPromise = null;

    const selectedVariantIds = () => {
      const ids = [];
      visibleItems().forEach((item) => {
        const checkbox = item.querySelector('[data-fbt-checkbox]');
        const variantId = Number(item.dataset.variantId || 0);
        if (checkbox?.checked && !checkbox.disabled && variantId) ids.push(variantId);
      });
      return ids;
    };

    const setButtonState = () => {
      if (!button) return;
      const ids = selectedVariantIds();

      if (!ids.length) {
        button.disabled = true;
        button.classList.remove('is-added');
        button.textContent = defaultLabel;
        return;
      }

      const allAlreadyInCart = cartStateLoaded && ids.every((id) => cartVariantIds.has(String(id)));

      if (allAlreadyInCart) {
        button.disabled = true;
        button.classList.add('is-added');
        button.textContent = 'Added';
      } else {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = defaultLabel;
      }
    };

    const syncCartState = async (force = false) => {
      if (cartSyncPromise && !force) return cartSyncPromise;

      cartSyncPromise = fetch((window.routes?.cart_url || '/cart') + '.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
        .then((response) => {
          if (!response.ok) throw new Error('cart-state');
          return response.json();
        })
        .then((cart) => {
          cartVariantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));
          cartStateLoaded = true;
          setButtonState();
          return cart;
        })
        .catch((error) => {
          console.error('FBT cart state error:', error);
          cartStateLoaded = false;
          return null;
        })
        .finally(() => {
          cartSyncPromise = null;
        });

      return cartSyncPromise;
    };

    const syncCurrentVariant = () => {
      const item = root.querySelector('[data-current-product="true"]');
      const script = page?.querySelector('variant-selects script[data-selected-variant]');
      if (!item || !script?.textContent) return;

      try {
        const variant = JSON.parse(script.textContent);
        if (variant?.id) item.dataset.variantId = variant.id;
        if (typeof variant?.price === 'number') item.dataset.price = variant.price;
        item.dataset.variantAvailable = variant?.available === false ? 'false' : 'true';
      } catch (e) {}
    };

    const visibleItems = () =>
      Array.from(root.querySelectorAll('[data-fbt-item]')).filter((item) => !item.hidden);

    const syncSeparators = () => {
      root.querySelectorAll('[data-fbt-plus]').forEach((plus) => (plus.hidden = true));
      root.querySelectorAll('[data-fbt-item]').forEach((item) => item.classList.remove('is-first-visible'));

      const visible = visibleItems();
      visible.forEach((item, index) => {
        if (index === 0) {
          item.classList.add('is-first-visible');
          return;
        }
        const plus = item.previousElementSibling;
        if (plus?.matches('[data-fbt-plus]')) plus.hidden = false;
      });

      root.dataset.visibleCount = String(visible.length);
      return visible;
    };

    const updateArrows = () => {
      if (!itemsWrap || !prev || !next) return;

      const count = visibleItems().length;
      const isDesktop = window.matchMedia('(min-width:750px)').matches;
      const hasOverflow = itemsWrap.scrollWidth > itemsWrap.clientWidth + 2;
      const canScroll = isDesktop ? count >= 4 && hasOverflow : hasOverflow;

      prev.hidden = !canScroll;
      next.hidden = !canScroll;

      if (!canScroll) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      const max = itemsWrap.scrollWidth - itemsWrap.clientWidth;
      prev.disabled = itemsWrap.scrollLeft <= 2;
      next.disabled = itemsWrap.scrollLeft >= max - 2;
    };

    const applyEligibility = () => {
      syncCurrentVariant();

      const city = selectedCity().trim().toLowerCase();
      const outsideQuetta = city !== '' && city !== 'quetta';

      root.querySelectorAll('[data-fbt-item]').forEach((item) => {
        const isQuettaOnly = item.dataset.quettaOnly === 'true';
        const unavailable = item.dataset.variantAvailable === 'false';
        const hide = unavailable || (outsideQuetta && isQuettaOnly);

        item.hidden = hide;

        const checkbox = item.querySelector('[data-fbt-checkbox]');
        if (checkbox && hide) checkbox.checked = false;
      });

      const visible = syncSeparators();
      root.hidden = visible.length < 2;
      requestAnimationFrame(updateArrows);
    };

    const updateTotal = () => {
      applyEligibility();
      if (root.hidden) return;

      let cents = 0;
      visibleItems().forEach((item) => {
        const checkbox = item.querySelector('[data-fbt-checkbox]');
        if (checkbox?.checked && !checkbox.disabled) cents += Number(item.dataset.price || 0);
      });

      if (total) total.textContent = fmt(cents, currency);
      setButtonState();
    };

    const refreshCartUi = async (addData) => {
      try {
        const cartItems = document.querySelector('cart-drawer-items');
        if (addData?.sections && cartItems && typeof cartItems.updateSections === 'function') {
          cartItems.updateSections(addData.sections);
        }

        if (addData?.sections?.['cart-icon-bubble']) {
          const iconTarget = document.getElementById('cart-icon-bubble');
          const iconDoc = new DOMParser().parseFromString(addData.sections['cart-icon-bubble'], 'text/html');
          const iconWrapper = iconDoc.querySelector('#shopify-section-cart-icon-bubble');
          if (iconTarget && iconWrapper) iconTarget.innerHTML = iconWrapper.innerHTML;
        }

        const cart = await syncCartState(true);
        if (cart) {
          document.querySelectorAll('[data-cart-count]').forEach((element) => {
            const countText = cart.item_count >= 100 ? '99+' : String(cart.item_count);
            element.textContent = element.closest('.cart-text') ? '(' + countText + ')' : countText;
          });

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        }
      } catch (error) {
        console.error('FBT cart UI refresh error:', error);
      }
    };

    root.querySelectorAll('[data-fbt-checkbox]').forEach((cb) =>
      cb.addEventListener('change', updateTotal)
    );

    page?.addEventListener('change', () => {
      setTimeout(async () => {
        updateTotal();
        await syncCartState(true);
      }, 0);
    });

    document.addEventListener('cityChanged', () => setTimeout(updateTotal, 0));
    window.addEventListener('storage', (event) => {
      if (event.key === 'selected_city') updateTotal();
    });

    window.addEventListener('pageshow', () => {
      syncCartState(true);
    });

    itemsWrap?.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    prev?.addEventListener('click', () =>
      itemsWrap?.scrollBy({
        left: -Math.max(180, itemsWrap.clientWidth * 0.8),
        behavior: 'smooth'
      })
    );

    next?.addEventListener('click', () =>
      itemsWrap?.scrollBy({
        left: Math.max(180, itemsWrap.clientWidth * 0.8),
        behavior: 'smooth'
      })
    );

    button?.addEventListener('click', async () => {
      applyEligibility();
      await syncCartState(true);

      const selectedIds = selectedVariantIds();
      if (!selectedIds.length) return;

      const missingIds = selectedIds.filter((id) => !cartVariantIds.has(String(id)));

      if (!missingIds.length) {
        setButtonState();
        return;
      }

      button.disabled = true;
      button.classList.remove('is-added');
      button.textContent = 'Adding...';

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const sectionIds =
          cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: missingIds.map((id) => ({ id, quantity: 1 })),
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add FBT products.');
        }

        missingIds.forEach((id) => cartVariantIds.add(String(id)));
        cartStateLoaded = true;

        await refreshCartUi(data);

        button.textContent = 'Added';
        button.classList.add('is-added');
        button.disabled = true;
      } catch (error) {
        console.error('FBT add error:', error);
        button.textContent = defaultLabel;
        button.classList.remove('is-added');
        button.disabled = false;
      }
    });

    updateTotal();
    syncCartState(true);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-ukh-fbt]').forEach(init);
    if (scope.matches?.('[data-ukh-fbt]')) init(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ukh-loyalty-points"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = (root) => {
      if (!root) return;
      const page = root.closest('.main-product-redesign');
      const value = root.querySelector('[data-ukh-loyalty-value]');
      const script = page?.querySelector('variant-selects script[data-selected-variant]');
      if (!value || !script?.textContent) return;

      try {
        const variant = JSON.parse(script.textContent);
        if (typeof variant?.price === 'number') {
          value.textContent = Math.round(variant.price / 100).toLocaleString();
        }
      } catch (e) {}
    };

    const init = (scope = document) => {
      scope.querySelectorAll?.('[data-ukh-loyalty]').forEach((root) => {
        if (root.dataset.loyaltyReady === 'true') return;
        root.dataset.loyaltyReady = 'true';
        update(root);

        const page = root.closest('.main-product-redesign');
        page?.addEventListener('change', () => setTimeout(() => update(root), 0));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
